module.exports = __webpack_public_path__ + "img/icon-media-multiple.1c974884.svg";